<template>
  <div>
    

    <Elaborazioni />
   
  </div>
</template>

<script>
// @ is an alias to /src
import Elaborazioni from '@/components/Elaborazioni.vue'


export default {
  name: 'HomeView',
  components: {
    Elaborazioni,
  
  }
}
</script>
